import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

const Faq = ({ items, dark = false, testid = "faq" }) => {
  const [open, setOpen] = useState(null);
  return (
    <div className={`border-t ${dark ? "border-cream/15" : "border-ink/15"}`} data-testid={testid}>
      {items.map(([q, a], i) => (
        <div key={i} className={`border-b ${dark ? "border-cream/15" : "border-ink/15"}`}>
          <button
            onClick={() => setOpen(open === i ? null : i)}
            data-testid={`${testid}-question-${i}`}
            className="w-full flex items-center justify-between gap-6 py-5 text-left group"
          >
            <span className={`font-serif text-xl sm:text-2xl ${dark ? "text-cream" : "text-ink"} group-hover:text-gold transition-colors duration-300`}>
              {q}
            </span>
            <motion.span animate={{ rotate: open === i ? 45 : 0 }} transition={{ duration: 0.3 }} className="text-gold shrink-0">
              <Plus size={18} />
            </motion.span>
          </button>
          <AnimatePresence initial={false}>
            {open === i && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="overflow-hidden"
              >
                <p className={`pb-6 pr-10 text-sm leading-relaxed ${dark ? "text-cream/70" : "text-ink/70"}`} data-testid={`${testid}-answer-${i}`}>
                  {a}
                </p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
};

export default Faq;
